const MIN_REMAINING_MS = 15 * 60 * 1000;

/**
 * Returns the timestamp of the next hour o'clock.
 * If less than 15 minutes remain until that hour, skips to the one after.
 *
 * Both client and server call this independently and get the same value
 * within the same time window — no prop drilling needed.
 */
export function getRequestExpiry(now = Date.now()): number {
  const msInHour = 60 * 60 * 1000;
  const nextHour = Math.ceil(now / msInHour) * msInHour;

  if (nextHour - now < MIN_REMAINING_MS) {
    return nextHour + msInHour;
  }

  return nextHour;
}
